import { Tag } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type PeriodInterval } from '../models/periodInterval';
import {
  isActivePeriod,
  isFuturePeriod,
  isPastPeriod,
} from '../utils/dateTime';

export const BudgetPeriodStatusTag = ({
  period,
}: {
  period: PeriodInterval;
}) => {
  const { t } = useTranslation('global');

  if (isActivePeriod(period)) {
    return (
      <Tag variant="success" iconName="circle-active">
        {t('budget.budgetaryExercise.active')}
      </Tag>
    );
  }

  if (isFuturePeriod(period)) {
    return (
      <Tag variant="info" iconName="clock-filled">
        {t('budget.budgetaryExercise.future')}
      </Tag>
    );
  }

  if (isPastPeriod(period)) {
    return (
      <Tag variant="carbon" iconName="circle-strikeout">
        {t('budget.budgetaryExercise.closed')}
      </Tag>
    );
  }

  return null;
};
